import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { AppDomain } from '@ibk/shared-types';
import { useListAccountantEmissorContractProductsQuery, useListClientEmissorContractProductsQuery, } from '../services/contractProductsApi';
const EMPTY_PRODUCTS = [];
const EMPTY_CATEGORIES = [];
export function useEmissorContractProducts({ contractId, skip = false, }) {
    const appDomain = useAppSelector(selectAppDomain);
    const isAccountant = appDomain === AppDomain.ESCRITORIO;
    const shouldSkip = skip || !contractId;
    const queryArg = { contractId: contractId ?? '' };
    const accountantQuery = useListAccountantEmissorContractProductsQuery(queryArg, {
        skip: shouldSkip || !isAccountant,
    });
    const clientQuery = useListClientEmissorContractProductsQuery(queryArg, {
        skip: shouldSkip || isAccountant,
    });
    const activeQuery = isAccountant ? accountantQuery : clientQuery;
    const { data, isLoading, isError } = activeQuery;
    return {
        products: data?.products ?? EMPTY_PRODUCTS,
        categories: data?.categories ?? EMPTY_CATEGORIES,
        isLoading,
        isError,
    };
}
